import { gql } from "apollo-boost";

export const GET_USER_ACTIVE_ADDRESS_CHANGE_REQUEST = gql`
  query getUserActiveAddressChangeRequest($userEmail: String!) {
    getUserActiveAddressChangeRequest(userEmail: $userEmail) {
      eventId
      userId
      email
      createdAt
      updatedAt
      status
      active
      method
      reviewer
      redflags
      currentAddress {
        street
        city
        state
        zip
        country
        unit_number
        normalized_street
        normalized_city
        normalized_subdivision
        normalized_postal_code
        normalized_country_code
      }
      changeToAddress  {
        street
        city
        state
        zip
        country
        unit_number
        normalized_street
        normalized_city
        normalized_subdivision
        normalized_postal_code
        normalized_country_code
      }
    }
  }
`;

export const RESOLVE_ADDRESS_CHANGE_REQUEST = gql`
  mutation resolveAddressChangeRequest($eventId: Int!, $action: String!) {
    resolveAddressChangeRequest(eventId: $eventId, action: $action) {
      status
      code
      message
    }
  }
`;

export const GET_ADDRESS_CHANGE_REQUESTS = gql`
  query getAddressChangeRequests(
    $page: Int
    $active: Boolean
  ) {
    getAddressChangeRequests(
      page: $page,
      active: $active
    ) {
      eventId
      userId
      email
      createdAt
      updatedAt
      status
      active
      method
      reviewer
      redflags
      currentAddress {
        street
        city
        state
        zip
        country
        unit_number
        normalized_street
        normalized_city
        normalized_subdivision
        normalized_postal_code
        normalized_country_code
      }
      changeToAddress  {
        street
        city
        state
        zip
        country
        unit_number
        normalized_street
        normalized_city
        normalized_subdivision
        normalized_postal_code
        normalized_country_code
      }
    }
  }
`;